import React from 'react';
import { Check } from 'lucide-react';
export function Promise() {
  const benefits = ['Full MLS listing and Realtor.com syndication', 'Professional photography and virtual tours', 'Expert pricing strategy and negotiation', 'Licensed, experienced listing agents', 'Contract to close transaction management'];
  return <section className="py-20 md:py-32 bg-white" data-id="element-231">
      <div className="container mx-auto px-4 md:px-6" data-id="element-232">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-233">
          {/* Content Column */}
          <div className="order-2 lg:order-1" data-id="element-234">
            <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-235">
              The 1% Promise
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight mb-6" data-id="element-236">
              Why pay more commission for the same service?
            </h2>
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed" data-id="element-237">
              Paying high commissions doesn't guarantee better service. Our 1%
              listing model leverages modern technology and proven strategy to
              sell your home quickly and for top dollar. You get the same
              high-touch, full-service experience as a traditional agent. You
              just keep more of your equity at closing.
            </p>

            <ul className="space-y-4" data-id="element-238">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-239">
                  <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-240">
                    <Check className="w-3.5 h-3.5 text-gold" data-id="element-241" />
                  </div>
                  <span className="text-charcoal font-medium" data-id="element-242">{benefit}</span>
                </li>)}
            </ul>
          </div>

          {/* Image Column */}
          <div className="order-1 lg:order-2 relative" data-id="element-243">
            <div className="relative z-10 aspect-[4/5] md:aspect-square lg:aspect-[4/5] overflow-hidden rounded-sm" data-id="element-244">
              <img src="https://cdn.magicpatterns.com/uploads/nu9Q4k4ob6RhjENngJgj2W/kailun-zhang-byUl6e8v28U-unsplash.jpg" alt="Beautiful Arizona home interior" className="w-full h-full object-cover" data-id="element-245" />
            </div>
            {/* Decorative Offset Frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-gold z-0 hidden md:block rounded-sm" data-id="element-246" />
          </div>
        </div>
      </div>
    </section>;
}